import { css, type Theme } from "@emotion/react";

export const descriptor = css`
  display: flex;
  gap: 0.5rem;
`;

export const button = (theme: Theme) => css`
  padding: 0.25rem 0.5rem;
  &:hover,
  &:active {
    color: ${theme.system.textLabelEmphasis};
    background-color: ${theme.system.backgroundBase};
    border-color: ${theme.system.borderBase};
  }
`;
